export default __webpack_public_path__ + "static/media/zvire_barva-min.42e8d7fc.png";